<template>
  <div class="footer">
    <div
      v-if="
        typePlacesSelectedTickets.length > 0 &&
        typePlacesSelectedTickets.find((t) => t.variants.length)
      "
      class="type-tickets-select--wrapper"
      v-bind:class="{ selectTypeTicketsStep }"
    >
      <div
        class="type-tickets-select--switch-control"
        v-bind:class="{ close: !isOpenControlTypeTickets }"
        @click="() => (isOpenControlTypeTickets = !isOpenControlTypeTickets)"
        v-if="selectTypeTicketsStep"
      >
        <img :src="switchControlSelectTypeSVG" alt="" />
      </div>
      <div v-if="selectTypeTicketsStep && isOpenControlTypeTickets">
        <div
          v-for="(ticket, index) in typePlacesSelectedTickets"
          :key="`type-tickets-select--select-block-${index}`"
          class="type-tickets-select--select-block"
        >
          <div class="type-tickets-select--select-list">
            <div
              :key="`${variants.name}-${index}`"
              v-for="(variants, index) in ticket.variants"
              class="type-tickets-select--select-list-item"
            >
              <div class="type-tickets-select--select-list-item-select">
                <div
                  class="type-tickets-select--select-list-item-select-minus"
                  @click="
                    () =>
                      decreaseTicketTypeHandler(ticket.name, variants.typeId)
                  "
                ></div>
                <div class="type-tickets-select--select-list-item-select-name">
                  <p>
                    {{
                      cart.tickets.filter(
                        ({ name, typeId }) =>
                          name === ticket.name && typeId === variants.typeId,
                      ).length
                    }}
                    {{ variants.Name }}
                  </p>
                </div>
                <div
                  class="type-tickets-select--select-list-item-select-plus"
                  @click="
                    () =>
                      increaseTicketTypeHandler(ticket.name, variants.typeId)
                  "
                ></div>
              </div>
              <div class="type-tickets-select--select-list-item-info">
                <p>{{ ticket.name }}</p>
                <p>{{ variants.Sum }} {{ setting.currency }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="hall-basket-wrapper">
      <div class="footer-desktop">
        <div
          v-if="!session.NoSeats"
          class="place-type-list"
          v-bind:class="{ selectedPlace: cart.tickets.length }"
        >
          <div
            class="place-type"
            v-for="price in session.Prices"
            :key="price.Id"
          >
            <span
              class="place-type-icon"
              :style="{ background: getColor(price) }"
            ></span>
            <span>{{ price.Name }} {{ price.Sum }} {{ setting.currency }}</span>
          </div>
          <div class="place-type">
            <span
              class="place-type-icon"
              :style="{ background: '#59636b' }"
            ></span>
            <span>Место занято</span>
          </div>
        </div>
        <div class="basket-info" v-if="cart.tickets.length > 0">
          <div
            v-if="typePlacesSelectedTickets.length > 0 && selectTypeTicketsStep"
            v-for="(ticket, index) in typePlacesSelectedTickets"
            :key="index"
          >
            <label class="basket-info-label">
              {{
                `${
                  cart.tickets.filter(
                    ({ name, typeId }) => name === ticket.name && typeId,
                  ).length
                } из ${countTicketString(
                  cart.tickets.filter(({ name }) => name === ticket.name)
                    .length,
                  true,
                )}`
              }}
              за
              {{ costAllPrice }}
              {{ setting.currency }}
            </label>
            <label class="basket-info-label basket-info-label-gray">{{
              ticket.name
            }}</label>
          </div>
          <label
            v-if="
              !selectTypeTicketsStep &&
              cart.tickets.filter(({ price }) => price).length
            "
            class="basket-info-label"
          >
            {{ countTicketString(cart.tickets.length) }} за
            {{ cartTicketsSum }}
          </label>

          <label
            v-else-if="cart.tickets.filter(({ price }) => price).length"
            class="basket-info-label"
          >
            Сумма: {{ cartTicketsSum }}
          </label>
          <label
            v-if="cart.tickets.filter(({ price }) => price).length"
            class="basket-info-label basket-info-label-gray"
            >Без сервисного сбора</label
          >
        </div>
        <div class="basket-step" v-if="cart.tickets.length > 0">
          <div
            class="basket-btn"
            v-bind:class="{
              disabled: false,
            }"
            @click="reserveTicket"
          >
            <span class="btn-icon"></span>
            <span class="btn-label">{{ basketBtnText }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import urlQueryParts from '../../../helpers/urlQueryParts';

export default {
  name: 'Footer',

  data() {
    return {
      switchControlSelectTypeSVG: require('../../../assets/switch-control-select-type.svg'),
      isOpenControlTypeTickets: true,
      selectTypeTicketsStep: false,
    };
  },

  computed: {
    ...mapState(['session', 'cart', 'bar', 'errors', 'setting', 'theatre', 'movie']),
    costAllPrice() {
      const ticketsWithPrice = this.cart.tickets.filter(
        ({ name, price }) => name && price,
      );
      const ticketsPricesSum = ticketsWithPrice.reduce(
        (acc, item) => acc + item.price,
        0,
      );
      const maxSeats = this.theatre.MaxSeats ? this.theatre.MaxSeats : 5;

      if (
        ticketsWithPrice.length >= maxSeats &&
        this.$route.params.theatreId === 'ck8k3jcgs3ch50773nugv3ejn' /* ||
        this.$route.params.theatreId === 'cl526eslgrikk0929tzb3pe1l' */
      ) {
        return ticketsPricesSum * 0.9;
      }

      return ticketsPricesSum;
    },

    basketBtnText() {
      if (this.movie.IsEventRegister) {
        return 'Зарегистрироваться';
      }
      
      if (
        this.cart.tickets.length &&
        this.cart.tickets.filter(({ price }) => price === 0).length ===
          this.cart.tickets.length
      ) {
        return 'Получить';
      }

      if (!this.selectTypeTicketsStep) return 'Купить';

      if (this.cart.tickets.filter(({ price }) => !price).length) {
        return `Выберите тип для ${this.countTicketString(
          this.cart.tickets.filter(({ price }) => !price).length,
          true,
        )} `;
      }

      return 'Купить';
    },
    cartTicketsSum() {
      const ticketsWithPrice = this.cart.tickets.filter(
        ({ name, price }) => name && price,
      );

      let sum = 0;
      this.cart.tickets.forEach((ticket) => {
        sum += ticket.price;
      });

      const maxSeats = this.theatre.MaxSeats ? this.theatre.MaxSeats : 5;

      if (
        ticketsWithPrice.length >= maxSeats &&
        this.$route.params.theatreId === 'ck8k3jcgs3ch50773nugv3ejn' /* ||
          this.$route.params.theatreId === 'cl526eslgrikk0929tzb3pe1l' */
      ) {
        return sum * 0.9 + ' ' + this.setting.currency;
      }

      return sum + ' ' + this.setting.currency;
    },
    typePlacesSelectedTickets() {
      return this.cart.tickets
        .filter(
          (ticket, index, array) =>
            !array.slice(0, index).find((i) => i.name == ticket.name),
        )
        .map(({ name, variants }) => ({
          name,
          variants,
          count: this.cart.tickets.filter((i) => i.name === name).length,
        }));
    },
  },

  methods: {
    decreaseTicketTypeHandler(typeTicketName, typeDiscountTicket) {
      const changeTicket = this.cart.tickets.find(
        (ticket) =>
          ticket.name === typeTicketName &&
          ticket.typeId === typeDiscountTicket,
      );

      this.cart.tickets = this.cart.tickets.map((ticket) => {
        if (ticket.id === changeTicket.id) {
          this.cart.sum -= changeTicket.price;
          this.cart.ticketSum -= changeTicket.price;
          return { ...ticket, price: null, typeId: null };
        }

        return ticket;
      });
    },
    increaseTicketTypeHandler(typeTicketName, typeDiscountTicket) {
      const changeTicket = this.cart.tickets.find(
        (ticket) =>
          !ticket.price && !ticket.typeId && ticket.name === typeTicketName,
      );

      this.cart.tickets = this.cart.tickets.map((ticket) => {
        if (ticket.id === changeTicket.id) {
          const selectedVariants = ticket.variants.find(
            ({ typeId }) => typeId === typeDiscountTicket,
          );
          this.cart.sum += selectedVariants.Sum;
          this.cart.ticketSum += selectedVariants.Sum;
          return {
            ...ticket,
            price: selectedVariants.Sum,
            typeId: typeDiscountTicket,
          };
        }

        return ticket;
      });
    },
    log: (msg) => console.log(msg),
    getColor(price) {
      return price.Color.slice(0, -2);
    },
    countTicketString(tickets, suffOv) {
      if (suffOv) {
        return tickets < 2 ? `${tickets} билета` : `${tickets} билетов`;
      }

      return tickets === 1
        ? `${tickets} билет`
        : tickets > 1 && tickets < 5
        ? `${tickets} билета`
        : `${tickets} билетов`;
    },
    reserveTicket() {
      if (
        !this.selectTypeTicketsStep &&
        this.cart.tickets.some((ticket) => ticket.variants.length > 1)
      ) {
        this.selectTypeTicketsStep = !this.selectTypeTicketsStep;
        return;
      }

      if (
        this.cart.tickets.every(({ typeId }) => typeId) ||
        this.session.NoSeats
      ) {
        const theatreAndSessionPart = `${this.$route.params.theatreId}/${this.$route.params.session}`;

        this.$store
          .dispatch('reserveTicket', {
            theatreId: this.$route.params.theatreId,
            sessionId: this.$route.params.session,
          })
          .then(() => {
            if (this.errors.length) {
              this.$router.push(
                `/${theatreAndSessionPart}/hall${urlQueryParts(
                  this.$route.query,
                )}`,
              );
            } else {
              if (false) { //временное отключение бара
              // if (this.bar && this.bar.length && this.theatre.HasBar) { 
                this.$router.push(
                  `/${theatreAndSessionPart}/bar${urlQueryParts(
                    this.$route.query,
                  )}`,
                );
              } else if (
                this.session &&
                this.session.Hall &&
                this.session.Hall.HallType &&
                this.session.Hall.HallType.Name === 'Мероприятия'
              ) {
                this.$router.push(
                  `/${theatreAndSessionPart}/support-cultural-program${urlQueryParts(
                    this.$route.query,
                  )}`,
                );
              } else {
                this.$router.push(
                  `/${theatreAndSessionPart}/buy${urlQueryParts(
                    this.$route.query,
                  )}`,
                );
              }
            }
          });
      }
    },
  },
};
</script>

<style src="./Footer.scss" lang="scss"></style>
